
import React, { useEffect } from "react";

import dateNow from "../utility/dateNow";

//---------------------------------------------
//Funciones para filtrar arreglos
//---------------------------------------------
const date = dateNow();
// useEffect(() => {     
//     date = dateNow();

// }, []); 
//--------------------------
//Filta arreglos por fechas para darle un tiempo de vida a las historias de 24hrs
//--------------------------
const filterDateHistoryArray = async (array ) => {
    var arrayUserHistory = []
    var minusDate
    var currentDay = new Date(date)
    var fiterDateArray = array.filter(array =>  {          
    var dayComparation = new Date(array.createDateUserPublication)
        minusDate = (currentDay - dayComparation)
    
        console.log('minusDate ->', minusDate)
         if(minusDate < 86400000){
       
          arrayUserHistory.push(
               {
               userPublicationId         : array.userPublicationId,
               userPublicationPhoto      : array.userPublicationPhoto, 
               createDateUserPublication : array.createDateUserPublication,
               userId                    : array.userId,
               totalLikes                : array.totalLikes,
               totalComments             : array.totalComments,
               followedId                : array.followedId
               }  
          )
         }
       }) 
       debugger
       console.log('array filter -> ', arrayUserHistory )
       return await  arrayUserHistory      
 }

 export default {
    filterDateHistoryArray,
}